import React from "react";
import styled from "@emotion/styled";
import CartTotalValues from "@components/CartTotalValues";
import CartCheckoutButton from "@components/CartCheckoutButton";
import CartTotalsContainer from "@components/CartTotalsContainer";

const CartLargeScreen = styled.div`
  @media (max-width: 1100px) {
    display: none;
  }
`;

const CartOrderTotal = () => {
  return (
    <CartTotalsContainer containerWidth={"350px"}>
      <CartTotalValues />
      <CartLargeScreen>
        <CartCheckoutButton />
      </CartLargeScreen>
    </CartTotalsContainer>
  );
};

export default CartOrderTotal;
